import { render, staticRenderFns } from "./OptionInputModal.vue?vue&type=template&id=15815081&scoped=true&"
import script from "./OptionInputModal.vue?vue&type=script&lang=js&"
export * from "./OptionInputModal.vue?vue&type=script&lang=js&"
import style0 from "./OptionInputModal.vue?vue&type=style&index=0&id=15815081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15815081",
  null
  
)

export default component.exports